const getRelativeUrl = (url: string): string => {
	if (process.env.ENABLE_CLOUDFRONT === 'true' && typeof window !== 'undefined') {
		const substring = url.split('external-assets');
		const host = window.location.origin;

		return `${host}/external-assets${substring[1]}`;
	}
	return url;
};

export default getRelativeUrl;
